export const DEFAULT_CENTER = [Number('56.509166'), Number('84.969855')]

export const DEFAULT_ZOOM = 6
export const DEFAULT_ZOOM_MOBILE = 9
export const ZOOM_BY_POINT = 15
export const ZOOM_BY_POINT_MOBILE = 17

export const EARTH_RADIUS = 6371
